import { generateTypes } from 'reducers/utils/HttpReducerHelper';
import { playbookContent } from './playbook/types';

const coursesRequest = generateTypes('LEARNING', 'COURSES');
const LRS_HEALTH_CHECK_SUCCESS = 'platfi-ui-app/LEARNING/LRS_HEALTH_CHECK_SUCCESS';
const LRS_HEALTH_CHECK_FAILURE = 'platfi-ui-app/LEARNING/LRS_HEALTH_CHECK_FAILURE';
const START_LRS_HEALTH_CHECK_POLLING = 'platfi-ui-app/LEARNING/START_LRS_HEALTH_CHECK_POLLING';
const STOP_LRS_HEALTH_CHECK_POLLING = 'platfi-ui-app/LEARNING/STOP_LRS_HEALTH_CHECK_POLLING';
const REQUEST_LESSON_URL = 'platfi-ui-app/LEARNING/REQUEST_LESSON_URL';

export {
  coursesRequest,
  playbookContent,
  LRS_HEALTH_CHECK_SUCCESS,
  LRS_HEALTH_CHECK_FAILURE,
  START_LRS_HEALTH_CHECK_POLLING,
  STOP_LRS_HEALTH_CHECK_POLLING,
  REQUEST_LESSON_URL,
};
